import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FiHome, FiUsers, FiLayers, FiFolder, FiBarChart2, FiLogOut, FiMenu, FiX, FiExternalLink, FiFileText, FiMessageSquare, FiBell } from 'react-icons/fi';

const AdminNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { path: '/admin', label: 'لوحة التحكم', icon: FiHome },
    { path: '/admin/applicants', label: 'المتقدمين', icon: FiUsers },
    { path: '/admin/teams', label: 'الفرق', icon: FiLayers },
    { path: '/admin/projects', label: 'المشاريع', icon: FiFolder },
    { path: '/admin/stats', label: 'الإحصائيات', icon: FiBarChart2 },
    { path: '/admin/notifications', label: 'الإشعارات', icon: FiBell },
    { path: '/admin/discarded', label: 'النماذج المهملة', icon: FiFileText },
    { path: '/admin/feedback', label: 'ملاحظات المستخدمين', icon: FiMessageSquare }
  ];

  return (
    <>
      {/* Top Header - Mobile */}
      <div className="lg:hidden fixed top-0 left-0 right-0 bg-[#05339c] text-white z-50">
        <div className="flex items-center justify-between px-4 h-16">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="p-2 rounded-lg hover:bg-white/10 transition-all"
          >
            {isMobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
          <h1 className="text-lg font-bold">هاكاثون قمة</h1>
          <button
            onClick={handleLogout}
            className="p-2 rounded-lg hover:bg-white/10 transition-all"
          >
            <FiLogOut size={20} />
          </button>
        </div>
      </div>

      {/* Sidebar - Desktop */}
      <aside className={`hidden lg:flex fixed top-0 right-0 h-screen bg-[#05339c] text-white transition-all duration-300 z-40 flex-col ${
        isSidebarOpen ? 'w-64' : 'w-20'
      }`}>
        {/* Header */}
        <div className="p-6 flex items-center justify-between border-b border-white/10">
          {isSidebarOpen && (
            <div>
              <h2 className="text-xl font-bold text-yellow">قمّة</h2>
              <p className="text-xs text-white/70 mt-1">لوحة التحكم</p>
            </div>
          )}
          <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="p-2 rounded-lg hover:bg-white/10 transition-all"
          >
            <FiMenu size={20} />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 py-6 px-3 overflow-y-auto">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-4 px-4 py-3 rounded-xl mb-2 transition-all duration-200 ${
                  isActive
                    ? 'bg-yellow text-[#05339c] font-semibold'
                    : 'text-white/80 hover:bg-white/10 hover:text-white'
                }`}
                title={!isSidebarOpen ? item.label : ''}
              >
                <Icon size={22} />
                {isSidebarOpen && <span>{item.label}</span>}
              </Link>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="p-4 border-t border-white/10">
          <Link
            to="/"
            className="flex items-center gap-3 px-4 py-3 rounded-xl text-white/80 hover:bg-white/10 hover:text-white transition-all mb-2"
          >
            <FiExternalLink size={20} />
            {isSidebarOpen && <span>الموقع الرئيسي</span>}
          </Link>
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 px-4 py-3 rounded-xl w-full text-red-300 hover:bg-red-500/20 hover:text-red-200 transition-all"
          >
            <FiLogOut size={20} />
            {isSidebarOpen && <span>تسجيل الخروج</span>}
          </button>
        </div>
      </aside>

      {/* Mobile Sidebar */}
      {isMobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 z-40">
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => setIsMobileMenuOpen(false)}
          />
          <aside className="absolute top-0 right-0 bottom-0 w-64 bg-[#05339c] text-white overflow-y-auto">
            <div className="p-6">
              <h2 className="text-2xl font-bold text-yellow">قمّة</h2>
              <p className="text-sm text-white/70 mt-1">لوحة التحكم</p>
            </div>

            <nav className="px-3 pb-20">
              {navItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className={`flex items-center gap-4 px-4 py-3 rounded-xl mb-2 transition-all ${
                      isActive
                        ? 'bg-yellow text-[#05339c] font-semibold'
                        : 'text-white/80 hover:bg-white/10 hover:text-white'
                    }`}
                  >
                    <Icon size={22} />
                    <span>{item.label}</span>
                  </Link>
                );
              })}
            </nav>
          </aside>
        </div>
      )}
    </>
  );
};

export default AdminNav;
